import React from "react";
import Select from "react-select";

const MultiSelect = ({
  name,
  options,
  value,
  onChange,
  onBlur,
  isMulti = false,
  placeholder,
  isClearable,
}) => {
  return (
    <div>
      <Select
        closeMenuOnScroll={(e) => {
          try {
            const target = e.target;

            if (
              !target ||
              !target.nodeType ||
              typeof target.closest !== "function"
            ) {
              return true;
            }

            const isMenuScroll =
              target.closest('[class*="MenuList"]') ||
              target.closest('[class*="menu"]');

            return !isMenuScroll;
          } catch (error) {
            return true;
          }
        }}
        isMulti // This enables multi-select
        name={name}
        id={name}
        options={options || []}
        menuPortalTarget={document.body} // render menu in portal
        menuPosition="fixed" // position relative to viewport
        menuPlacement="auto"
        value={
          value && value.length > 0
            ? options.filter((option) => value.includes(option.value))
            : []
        } // Find selected roles
        onChange={(selectedOptions) => {
          // If options are selected, map to their values (role IDs), otherwise return an empty array
          const selectedValues = selectedOptions
            ? selectedOptions.map((option) => option.value)
            : [];
          onChange(selectedValues); // Pass the selected role IDs to the parent
        }}
        onBlur={onBlur}
        placeholder={placeholder}
        isSearchable
        isClearable={isClearable}
        closeMenuOnSelect={false}
        styles={{
          menu: (provided) => ({
            ...provided,
            maxHeight: "200px",
            overflowY: "auto",
          }),
          menuList: (provided) => ({
            ...provided,
            maxHeight: "200px",
            overflowY: "auto",
          }),
          control: (provided) => ({
            ...provided,
            color: "#5e667b",
          }),
        }}
      />
    </div>
  );
};

export default MultiSelect;
